import { useGoogleMaps } from "~/composables/useGoogleMaps";

export default defineNuxtPlugin(() => {
  useGoogleMaps();
});
